
import React, { useEffect, useState } from "react";
import { BASE_API_URL, BASE_IMAGE_API_URL } from "../services/baseServices";
import MainLayout from "../layouts/MainLayout";
import Swal from 'sweetalert2';
import '../assets/styles/loader.css';
import '../assets/styles/pagination.css';
import axios from "axios";
// import ComingSoonImg from 'assets/img/authentication/under-maintenance.png';
import ComingSoonImg from '../assets/Images/coming.png';
import { useNavigate } from "react-router-dom";

export default function Brand() {

    const navigate = useNavigate();
    const [sessionUserData, setSessionUserData] = useState([]);
    const [contentTypeData, setContentTypeData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [dataSubLoading, setDataSubLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [nameInput, setNameInput] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [editingItem, setEditingItem] = useState(null);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setSessionUserData(userData);
        } else {
            navigate("/");
        }
    }, [navigate]);


    useEffect(() => {
        if (sessionUserData?.OrgId) {
            fetchContentByType();
        }
    }, [sessionUserData]);

    const fetchContentByType = async (type) => {
        setDataLoading(true);

        try {
            const response = await axios.get(`${BASE_API_URL}ADMINRoutes/GetDDL?OrgId=${sessionUserData?.Orgid}&UserId=${sessionUserData?.Id}`);
            const allItems = response.data.ResultData;

            const contentTypesRes = allItems.filter(item => item.DDLName === "ContentTypes");
            // console.log(contentTypesRes);

            setContentTypeData(contentTypesRes);
            setDataLoading(false);
        } catch (error) {
            console.error(`Error fetching ${type}:`, error);
            setDataLoading(false);
            return null;
        }
    };

    const filteredData = contentTypeData && contentTypeData.filter((item) => {
        const disValue = item?.DisplayValue?.toLowerCase() || '';

        const query = searchQuery.toLowerCase();

        return (
            disValue.includes(query)
        );
    });

    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 5;
    const totalPages = Math.ceil(filteredData.length / recordsPerPage);

    // Get current records to display
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);

    const getPaginationNumbers = () => {
        const visiblePages = [];
        if (totalPages <= 6) {
            for (let i = 1; i <= totalPages; i++) visiblePages.push(i);
        } else {
            if (currentPage <= 3) {
                visiblePages.push(1, 2, 3, "...", totalPages - 2, totalPages - 1, totalPages);
            }
            else if (currentPage > 3 && currentPage < totalPages - 2) {
                visiblePages.push(1, 2, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages - 1, totalPages);
            }
            else {
                visiblePages.push(1, 2, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            }
        }
        return visiblePages;
    };

    const handlePageClick = (page) => {
        if (page !== "...") setCurrentPage(page);
    };

    const handlePrevious = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleEditClick = (item) => {
        setEditMode(true);
        setEditingItem(item);
        setNameInput(item.DisplayValue);
    };

    const handleSubmit = async () => {
        if (!nameInput.trim()) return;

        try {
            setDataSubLoading(true);
            if (editMode && editingItem) {
                const payload = {
                    Id: editingItem.ItemId,
                    ContentTypeName: nameInput,
                    IsActive: 1,
                    UpdatedBy: sessionUserData?.Id,
                };
                await axios.post(`${BASE_API_URL}ADMINRoutes/Updtcontenttype`, payload);
            } else {
                const payload = {
                    ContentTypeName: nameInput,
                    IsActive: 1,
                    CreatedBy: sessionUserData?.Id,
                    OrgId: sessionUserData?.OrgId,
                };
                await axios.post(`${BASE_API_URL}ADMINRoutes/Addcontenttype`, payload);
            }

            setNameInput('');
            setDataSubLoading(false);
            setEditMode(false);
            setEditingItem(null);

            fetchContentByType();

        } catch (error) {
            console.error("Error submitting content type:", error);
            setDataSubLoading(false);
        }
    };

    const handleClear = () => {
        setNameInput('');
        setEditMode(false);
        setEditingItem(null);
        setDataSubLoading(false);
    };


    return (
        <MainLayout>
        <div
          className="content"
          style={{
            height: '80vh',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '12px',
            textAlign: 'center',
            padding: '0 20px',
          }}
        >
          <img
            src={ComingSoonImg}
            // src="assets/img/authentication/under-maintenance.png"
            className="img-fluid"
            alt="Under Maintenance"
            style={{ maxWidth: '100%', height: 'auto' }}
          />
          {/* <h2>We are Under Maintenance</h2> */}
          {/* <h2>Coming Soon</h2>
          <p style={{ maxWidth: '400px', color: '#555', fontStyle: 'italic' }}>
            Something exciting is brewing behind the scenes. Stay tuned and get ready to explore a new experience — it’s worth the wait!
          </p> */}
        </div>
      </MainLayout>
      
    )
}